module.exports = __webpack_public_path__ + "static/media/Lairon_gaussian2.fde7477e.png";